import { useState, useEffect } from "react";

const resolveInlineDebtData = () => {
    if (typeof window !== "undefined" && window.debtClockConfig?.debtData) {
        return window.debtClockConfig.debtData;
    }
    return null;
};

const useFetchDebtData = () => {
    const initialData = resolveInlineDebtData();
    const [debtData, setDebtData] = useState(initialData);
    const [isLoading, setIsLoading] = useState(!initialData);
    const [error, setError] = useState(null);

    useEffect(() => {
        const inlineData = resolveInlineDebtData();
        if (inlineData && Object.keys(inlineData).length) {
            setDebtData(inlineData);
            setIsLoading(false);
            setError(null);
            return;
        }

        setDebtData(null);
        setIsLoading(false);
        setError(new Error("Debt clock data missing."));
    }, []);

    return { debtData, isLoading, error };
};

export default useFetchDebtData;
